import { render, staticRenderFns } from "./EditEmailModal.vue?vue&type=template&id=5f4ceda3"
import script from "./EditEmailModal.vue?vue&type=script&lang=ts"
export * from "./EditEmailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports